export class Pregunta{
  constructor(
    public _id: string,
    public pregunta: string,
    public respuesta: string
  ){
  }
}
